export default {"src":"/_next/static/media/LOGO 2.c2b13bd9.svg","height":60,"width":457,"blurWidth":0,"blurHeight":0};